<template>
  <footer>
    <div class="h-10 text-xl font-semibold text-white items-center text-center w-full bg-gray-900">
      <span><i class="far fa-copyright"></i> Dhanz.</span>
    </div>
  </footer>
</template>

<script>
export default {

}
</script>

<style>

</style>